import { render, staticRenderFns } from "./author-info.vue?vue&type=template&id=6a822158&scoped=true&"
import script from "./author-info.vue?vue&type=script&lang=js&"
export * from "./author-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a822158",
  null
  
)

export default component.exports